// Tableau's classic 10-color palette (same as d3's schemeTableau10).
const seriesColors = [
    "#4E79A7",
    "#F28E2B",
    "#E15759",
    "#76B7B2",
    "#59A14F",
    "#EDC948",
    "#B07AA1",
    "#FF9DA7",
    "#9C755F",
    "#BAB0AC",
] as const;

/** Deterministic color from a numeric stream id — stable across re-renders. */
export function stableStreamColor(streamId: number): string {
    const index = Math.abs(Math.trunc(streamId * 2654435761)) % seriesColors.length;
    return seriesColors[index];
}
